import { Controller } from "@hotwired/stimulus"

// Ticks an element's text content with the live elapsed-seconds counter
// while a long-running operation is :running. Reads started_at + status
// from data attributes set by the kpi_grid partial. When the report
// flips to a terminal status (completed / failed / cancelled), the
// outer Turbo broadcast replaces the element entirely — this controller
// disconnects + reconnects with the new (non-running) status value, so
// the interval auto-stops.
//
// Console logging prefix: [live-elapsed]
export default class extends Controller {
  static values = {
    startedAt:   { type: String, default: "" },
    status:      { type: String, default: "" },
    durationMs:  { type: Number, default: 0  }
  }

  connect() {
    console.log(`[live-elapsed] connect: status=${this.statusValue} startedAt=${this.startedAtValue || "(empty)"}`)

    // Only tick while running. For terminal states the server already
    // wrote the final duration_display — leave it alone.
    if (this.statusValue !== "running") {
      return
    }

    const startedMs = Date.parse(this.startedAtValue)
    if (isNaN(startedMs)) {
      console.warn("[live-elapsed] invalid startedAt — skipping ticker")
      return
    }

    this.startedMs = startedMs
    this.render()
    this.interval = setInterval(() => this.render(), 1000)
  }

  render() {
    const elapsedMs = Date.now() - this.startedMs
    if (elapsedMs < 0) return

    const seconds = Math.floor(elapsedMs / 1000)
    // Same shape as InsightReport#duration_display (<1s shows ms, ≥1s shows s)
    this.element.textContent = seconds < 1
      ? `${elapsedMs}ms`
      : `${seconds}s`
  }

  disconnect() {
    console.log(`[live-elapsed] disconnect`)
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
